import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShieldCheck, Lock, CheckCircle2, XIcon } from 'lucide-react';
interface ExitIntentPopupProps {
  isOpen: boolean;
  onClose: () => void;
  onDecline: () => void;
}
const FULL_BUNDLE_URL = 'https://tumentesoberana.com/cart/48626810519771:1';
const MAIN_ONLY_URL = 'https://tumentesoberana.com/cart/48610738602203:1';
export function ExitIntentPopup({
  isOpen,
  onClose,
  onDecline
}: ExitIntentPopupProps) {
  const handleAccept = () => {
    window.open(FULL_BUNDLE_URL, '_blank', 'noopener,noreferrer');
    onClose();
  };
  const handleDecline = () => {
    window.open(MAIN_ONLY_URL, '_blank', 'noopener,noreferrer');
    onDecline();
  };
  return <AnimatePresence data-id="element-34">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.3
    }} className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" onClick={onClose} data-id="element-35">
          <motion.div initial={{
        opacity: 0,
        scale: 0.9,
        y: 30
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.9,
        y: 30
      }} transition={{
        duration: 0.4,
        type: 'spring',
        damping: 25
      }} className="bg-dark-800 border-2 border-gold-500/40 rounded-2xl max-w-lg w-full max-h-[90vh] overflow-y-auto relative" onClick={e => e.stopPropagation()} data-id="element-36">
            {/* Close button */}
            <button onClick={onClose} className="absolute top-3 right-3 text-gray-500 hover:text-white transition-colors z-10" data-id="element-37">
              <XIcon className="w-5 h-5" data-id="element-38" />
            </button>

            {/* Header Banner */}
            <div className="bg-gradient-to-r from-red-900/40 via-red-800/30 to-red-900/40 border-b border-gold-500/20 px-6 py-4 text-center" data-id="element-39">
              <span className="inline-block bg-red-600 text-white text-xs font-bold uppercase tracking-widest px-3 py-1 rounded-full mb-2 animate-pulse" data-id="element-40">
                ⏳ Oferta única — Solo en esta pantalla
              </span>
              <h2 className="text-xl md:text-2xl font-serif text-white leading-tight" data-id="element-41">
                🛡️ ¡Espera! No te vayas sin tu Blindaje Completo
              </h2>
              <p className="text-gray-300 text-sm mt-1" data-id="element-42">
                ¿Seguro que quieres dejar tu transformación a medias?
              </p>
            </div>

            {/* Body */}
            <div className="px-6 py-6" data-id="element-43">
              {/* Flashing discount badge */}
              <div className="text-center mb-5" data-id="element-44">
                <span className="inline-block bg-gold-500 text-dark-900 font-bold text-sm px-4 py-2 rounded-full shadow-[0_0_20px_rgba(201,168,76,0.4)] animate-[flash_2s_ease-in-out_infinite]" data-id="element-45">
                  🔥 30% DE DESCUENTO EN LOS EXTRAS
                </span>
              </div>

              {/* Main copy */}
              <p className="text-gray-300 text-sm text-center mb-2" data-id="element-46">
                Llévate el{' '}
                <span className="text-white font-semibold" data-id="element-47">
                  paquete completo de Blindaje Humano
                </span>{' '}
                y no dejes ningún flanco descubierto. Pasa de temer a la IA a
                ser el profesional que toda empresa necesita retener.
              </p>
              <p className="text-gray-400 text-xs text-center mb-6" data-id="element-48">
                Incluye el Anti-Manual + la Auditoría de Riesgo + las Cláusulas
                de Protección, todo en un solo paquete con precio especial.
              </p>

              {/* What's included */}
              <div className="bg-dark-900/60 rounded-xl p-4 mb-6 space-y-3" data-id="element-49">
                <p className="text-gold-400 text-xs font-bold uppercase tracking-wider mb-2" data-id="element-50">
                  Tu paquete completo incluye:
                </p>
                <div className="flex items-start gap-2" data-id="element-51">
                  <CheckCircle2 className="w-4 h-4 text-gold-500 flex-shrink-0 mt-0.5" data-id="element-52" />
                  <span className="text-gray-300 text-sm" data-id="element-53">
                    <span className="text-white font-medium" data-id="element-54">
                      El Anti-Manual de la IA
                    </span>{' '}
                    — Guía Maestra + Matriz de Irreemplazabilidad + Plan de 21
                    Días + Guiones de Negociación + Checklist + 5 Prompts de
                    Soberanía
                  </span>
                </div>
                <div className="flex items-start gap-2" data-id="element-55">
                  <CheckCircle2 className="w-4 h-4 text-gold-500 flex-shrink-0 mt-0.5" data-id="element-56" />
                  <span className="text-gray-300 text-sm" data-id="element-57">
                    <span className="text-white font-medium" data-id="element-58">
                      La Auditoría de los 10 Minutos
                    </span>{' '}
                    — Hoja de cálculo inteligente con tu Semáforo de Riesgo
                    personal
                  </span>
                </div>
                <div className="flex items-start gap-2" data-id="element-59">
                  <CheckCircle2 className="w-4 h-4 text-gold-500 flex-shrink-0 mt-0.5" data-id="element-60" />
                  <span className="text-gray-300 text-sm" data-id="element-61">
                    <span className="text-white font-medium" data-id="element-62">
                      Pack de Cláusulas Anty-IA
                    </span>{' '}
                    — 3 plantillas legales para blindar tus contratos y defender
                    tu tarifa
                  </span>
                </div>
              </div>

              {/* Pricing block */}
              <div className="bg-dark-900 rounded-xl p-5 border border-gold-500/20 mb-6 text-center" data-id="element-63">
                <div className="flex items-center justify-center gap-2 mb-1" data-id="element-64">
                  <Lock className="w-4 h-4 text-gold-500" data-id="element-65" />
                  <span className="text-gray-400 text-xs" data-id="element-66">
                    Precio especial solo disponible en esta pantalla
                  </span>
                </div>
                <div className="mb-1" data-id="element-67">
                  <span className="text-gray-500 line-through text-lg" data-id="element-68">
                    $23.51 USD
                  </span>
                </div>
                <div data-id="element-69">
                  <span className="text-4xl font-serif text-gold-500 font-bold" data-id="element-70">
                    $18.85
                  </span>
                  <span className="text-gold-500/70 text-lg ml-1" data-id="element-71">USD</span>
                </div>
                <p className="text-green-400 text-xs mt-1 font-medium" data-id="element-72">
                  ¡Te ahorras $4.66!
                </p>
              </div>

              {/* CTA Buttons */}
              <div className="space-y-3" data-id="element-73">
                <motion.button onClick={handleAccept} whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} className="w-full bg-gold-500 hover:bg-gold-400 text-dark-900 font-bold py-4 px-6 rounded-lg shadow-[0_0_25px_rgba(201,168,76,0.35)] transition-colors duration-300 text-base animate-[glow_2s_ease-in-out_infinite]" data-id="element-74">
                  <span className="block" data-id="element-75">
                    SÍ, ¡QUIERO EL PAQUETE COMPLETO POR $18.85!
                  </span>
                  <span className="block text-xs font-normal opacity-80 mt-1" data-id="element-76">
                    + Impuestos según tu país
                  </span>
                </motion.button>

                <button onClick={handleDecline} className="w-full text-gray-500 hover:text-gray-300 text-sm py-2 transition-colors underline underline-offset-2" data-id="element-77">
                  No gracias, continuar sin los extras →
                </button>
              </div>

              {/* Trust badge */}
              <div className="flex items-center justify-center gap-2 mt-4 text-gray-500 text-xs" data-id="element-78">
                <ShieldCheck className="w-4 h-4 text-green-500" data-id="element-79" />
                <span data-id="element-80">Pago seguro y cifrado · Acceso inmediato</span>
              </div>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}